import React from "react"
import { connect } from "react-redux"
import * as actionCreators from "../redux/action_creators"
import { alerts } from "../util/alert_error_utils"
import { makeToast } from "../util/toast_util"
import { appStrings } from "../common/strings/app_strings"
import { Link } from "react-router-dom"

const {
    title,
    titleSent,
    checkYourEmail,
    email,
    button,
    buttonSent,
} = appStrings.forgotPassword

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props)
        this.handleReset = this.handleReset.bind(this)

        this.state = {
            errorMessage: "",
            hasSent: false,
        }
    }

    componentDidUpdate(prevProps) {
        const { clearSettingsPassword } = this.props.ui
        // receive changes from ui.clearSettingsPassword
        if (
            !!clearSettingsPassword &&
            prevProps.ui.clearSettingsPassword !== clearSettingsPassword
        ) {
            this.setState({
                hasSent: true,
            })
        }
    }
    // cleanEmail removes spaces from the beginning and end of a string
    cleanEmail(emailStr) {
        return emailStr.toLowerCase().replace(/^\s*|\s*$/g, "")
    }

    handleReset(event) {
        event.preventDefault()

        const email = this.email.value
        const cleanedEmail = this.cleanEmail(email)
        const validationError = alerts[this.validateFields(cleanedEmail)]
        if (validationError) {
            // toast
            const msg = validationError.msg
            const ind = "danger"
            makeToast(msg, ind)
            return
        } else {
            this.props.forgotPassword(cleanedEmail)
        }
    }

    setError(message) {
        this.setState({ errorMessage: message })
    }

    validateFields(email) {
        if (email.length === 0) {
            return "emailRequired"
        }
        return null
    }

    componentDidMount() {
        this.email && this.email.focus()
    }

    render() {
        const { hasSent } = this.state
        return (
            <div className="container forgot-password">
                <form id="signin-form">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="center">
                                {!hasSent ? title : titleSent}
                            </h4>
                        </div>
                    </div>
                    {!hasSent ? (
                        <div className="row">
                            <div className="col-md-12 form-group">
                                <input
                                    type="email"
                                    id="forgot-password-email-input"
                                    ref={ref => (this.email = ref)}
                                    className="form-control"
                                    placeholder={email}
                                    tabIndex="1"
                                    required="true"
                                />
                            </div>
                        </div>
                    ) : (
                        <p className="submit-confirmation">{checkYourEmail}</p>
                    )}
                    <div className="form-actions">
                        {!hasSent ? (
                            <input
                                type="submit"
                                id="forgot-password-submit"
                                className="btn btn-primary btn-block btn-custom"
                                tabIndex="3"
                                value={button}
                                onClick={this.handleReset}
                            />
                        ) : (
                            <Link to="/signIn">
                                <button className="btn btn-primary btn-block btn-custom">
                                    {buttonSent}
                                </button>
                            </Link>
                        )}
                    </div>
                </form>
                <Link id="sign-up-link" to="/signIn">
                    <button className="btn btn-primary sign-in-button">
                        Sign in
                    </button>
                </Link>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return state
}

export default connect(
    mapStateToProps,
    actionCreators,
)(ForgotPassword)



// WEBPACK FOOTER //
// ./src/pages/forgot_password.jsx